import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import Ad from '../ad/ad';

// eslint-disable-next-line
export default class MostCreativePeopleCommunitySection extends Component {
  constructor(props) {
    super(props);
    this.screenLarge = true;
  }

  componentDidMount() {
    this.updateDisplay(get(this.props, 'activeSection'));
  }

  componentDidUpdate() {
    this.updateDisplay(get(this.props, 'activeSection'));
  }

  animatedScroll(element, to, duration) {
    if (duration <= 0) return;
    const difference = to - element.scrollTop;
    const perTick = difference / duration * 10;

    setTimeout(() => {
      // eslint-disable-next-line no-param-reassign
      element.scrollTop += perTick;
      if (element.scrollTop === to) return;
      this.animatedScroll(element, to, duration - 10);
    }, 10);
  }

  updateDisplay(activeSection) {
    if (activeSection && canUseDOM) {
      this.screenLarge = window.innerWidth > 640;
      const el = document.querySelector(
        `.mcp-community-section--${activeSection}:not(.scrolled)`
      );
      if (el) {
        this.animatedScroll(
          document.body,
          el.offsetTop + (this.screenLarge ? 130 : 190),
          100
        );
        el.classList.add('scrolled');
      }
    }
  }

  render() {
    const {
      combinedAdModel,
      index,
      people,
      nextPage,
      prevPage,
      activeSection
    } = this.props;

    const nextStyle = {
      minHeight: 473
    };

    const peopleList = get(people, 'rows') ? people.rows : null;
    const peopleListSections = [];

    if (peopleList && peopleList.length) {
      let i = 0;
      const chunk = 10;
      for (i; i < peopleList.length; i += chunk) {
        peopleListSections.push(peopleList.slice(i, i + chunk));
      }
    }

    return (
      <section
        className={`mcp-community-section mcp-community-section--${index}`}
        style={activeSection === index && this.screenLarge ? nextStyle : {}}
      >
        <Link
          to={
            activeSection === index
              ? '/most-creative-people-community'
              : `/most-creative-people-community/${index}/1`
          }
          className={`mcp-community-section__title-row mcp-community-section__title-row--${
            index
          }`}
        >
          <h2 className="mcp-community-section__title">{index}</h2>
          <img
            className={`mcp-community-section__title-icon
              ${
                activeSection === index
                  ? ' mcp-community-section__title-icon--active'
                  : ''
              }`}
            src="//images.fastcompany.net/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg"
            alt="arrow icon"
            title="arrow icon"
          />
        </Link>

        {peopleListSections.length && activeSection === index ? (
          <div className="mcp-community-section__list-container">
            {prevPage && this.screenLarge ? (
              <div className="mcp-community-section__prev-paddle">
                <Link
                  to={`/most-creative-people-community/${index}/${prevPage}`}
                >
                  <div className="mcp-community-section__prev-icon" />
                </Link>
              </div>
            ) : (
              ''
            )}
            <div className="mcp-community-section__list">
              {peopleListSections.map(section => (
                <div
                  key={`${section[0].full_name}`}
                  className="mcp-community-section__list-column"
                >
                  {section.map(person => (
                    <Link to={`/person/${person.url}`} key={person.full_name}>
                      {person.full_name}
                    </Link>
                  ))}
                </div>
              ))}

              {!this.screenLarge && (prevPage || nextPage) ? (
                <ul className="pagination mcp-community-section__pagination">
                  <li
                    className={`pagination__page pagination__page--prev${
                      !prevPage
                        ? ' mcp-community-section__pagination-page--inactive'
                        : ''
                    }`}
                  >
                    {prevPage ? (
                      <Link
                        to={`/most-creative-people-community/${index}/${
                          prevPage
                        }`}
                      >
                        Prev
                      </Link>
                    ) : (
                      <span className="pagination__link">Prev</span>
                    )}
                  </li>
                  <li
                    className={`pagination__page pagination__page--next${
                      !nextPage
                        ? ' mcp-community-section__pagination-page--inactive'
                        : ''
                    }`}
                  >
                    {nextPage ? (
                      <Link
                        to={`/most-creative-people-community/${index}/${
                          nextPage
                        }`}
                      >
                        Next
                      </Link>
                    ) : (
                      <span className="pagination__link">Next</span>
                    )}
                  </li>
                </ul>
              ) : (
                ''
              )}
            </div>

            {nextPage && this.screenLarge ? (
              <div className="mcp-community-section__next-paddle">
                <Link
                  to={`/most-creative-people-community/${index}/${nextPage}`}
                >
                  <div className="mcp-community-section__next-icon" />
                </Link>
              </div>
            ) : (
              ''
            )}
          </div>
        ) : (
          ''
        )}

        {index === 'j' ? (
          <div className="mcp-community-section__ff-ad-container">
            <Ad {...combinedAdModel} pos="btf" name="flexiblebillboard_1" />
            <Ad {...combinedAdModel} pos="btf" name="mobileparallax_1" />
          </div>
        ) : (
          ''
        )}
      </section>
    );
  }
}

MostCreativePeopleCommunitySection.propTypes = {
  /* eslint-disable */
  people: PropTypes.shape({}),
  combinedAdModel: PropTypes.shape({}).isRequired,
  index: PropTypes.string,
  nextPage: PropTypes.string,
  prevPage: PropTypes.string,
  activeSection: PropTypes.string
  /* eslint-enable */
};



// WEBPACK FOOTER //
// ./src/views/components/most_creative_people_community_section/most_creative_people_community_section.js